module.exports = __webpack_public_path__ + "media/assets/images/events/mkthap_sm_full-15127b6b0e13b18c36021f2a384f7bcc.jpeg";